import { useEffect, useState } from 'react';

interface ShareDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
}

export default function ShareDialog({ open, onClose, title }: ShareDialogProps) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!open) setCopied(false);
  }, [open]);

  if (!open) return null;

  const shareUrl = window.location.href;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-foreground-950/50" onClick={onClose} />
      <div className="relative z-10 w-full max-w-md rounded-lg border border-background-200 bg-background-50 p-6">
        <div className="mb-4 flex items-start justify-between gap-4">
          <div>
            <h3 className="font-heading text-lg font-700 text-foreground-950">分享内容</h3>
            <p className="mt-1 line-clamp-1 text-xs font-label text-foreground-500">{title}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-md text-foreground-500 transition-colors hover:bg-background-100"
          >
            <i className="ri-close-line" />
          </button>
        </div>

        <div className="flex items-center gap-2 rounded-md border border-background-300 bg-background-100 p-2">
          <input
            readOnly
            value={shareUrl}
            className="min-w-0 flex-1 bg-transparent px-2 text-sm font-label text-foreground-700 outline-none"
          />
          <button
            type="button"
            onClick={copy}
            className={`cursor-pointer whitespace-nowrap rounded-md px-4 py-2 text-sm font-label font-500 transition-colors ${
              copied ? 'bg-secondary-500 text-background-50' : 'bg-primary-500 text-background-50 hover:bg-primary-600'
            }`}
          >
            {copied ? '已复制' : '复制链接'}
          </button>
        </div>

        <div className="mt-5">
          <p className="mb-2 text-xs font-label text-foreground-500">分享到</p>
          <div className="flex flex-wrap gap-2">
            {[
              { icon: 'ri-wechat-line', label: '微信' },
              { icon: 'ri-weibo-line', label: '微博' },
              { icon: 'ri-bilibili-line', label: 'B站' },
              { icon: 'ri-link', label: '链接' },
            ].map((item) => (
              <span
                key={item.label}
                className="flex cursor-pointer items-center gap-1.5 rounded-md border border-background-300 px-3 py-2 text-xs font-label text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
              >
                <i className={item.icon} />
                {item.label}
              </span>
            ))}
          </div>
        </div>

        <p className="mt-4 text-center text-xs font-label text-foreground-400">
          提示：分享为前端演示功能，仅支持复制当前页面链接
        </p>
      </div>
    </div>
  );
}